import React from 'react';
import reactDOM from 'react-dom';
import { App } from './app/app';
import './styles/index.scss';

document.addEventListener('DOMContentLoaded', () => {
  reactDOM.render(<App />, document.getElementById('root'));
});
